module.exports = __webpack_public_path__ + "img/sub_support_9.8efa5fb8.png";